module.exports = __webpack_public_path__ + "img/mirror31.f685a628.jpg";